import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Firebase } from '../../firebase/config';
import AdminLayout from '../../Components/Admin/AdminLayout';

const ALL_LANGS = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'es', name: 'Español' },
  { code: 'it', name: 'Italiano' },
  { code: 'bg', name: 'Български' },
  { code: 'ru', name: 'Русский' },
  { code: 'uk', name: 'Українська' },
  { code: 'be', name: 'Беларуская' },
  { code: 'zh', name: '中文' },
  { code: 'fa', name: 'فارسی' },
];

const SETTINGS_DOC = 'appSettings/languages';

function AdminLanguages() {
  const { t } = useTranslation();
  const [enabled, setEnabled] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Firebase.firestore().doc(SETTINGS_DOC)
      .get()
      .then((doc) => {
        const data = doc.exists ? doc.data() : {};
        // Default: all enabled unless explicitly disabled
        const map = {};
        ALL_LANGS.forEach((l) => {
          map[l.code] = data[l.code] !== false;
        });
        setEnabled(map);
      })
      .catch(() => {
        const map = {};
        ALL_LANGS.forEach((l) => { map[l.code] = true; });
        setEnabled(map);
      })
      .finally(() => setLoading(false));
  }, []);

  const toggle = useCallback((code) => {
    setEnabled((prev) => ({ ...prev, [code]: !prev[code] }));
  }, []);

  const save = () => {
    setSaving(true);
    Firebase.firestore().doc(SETTINGS_DOC)
      .set(enabled, { merge: true })
      .then(() => { setSaving(false); })
      .catch(() => { setSaving(false); });
  };

  return (
    <AdminLayout>
      <h1>{t('admin.languages')}</h1>
      <p className="adminHint">{t('admin.languagesDesc')}</p>
      {loading ? (
        <p>{t('admin.loading')}</p>
      ) : (
        <>
          <table className="adminLangTable">
            <thead>
              <tr>
                <th>{t('admin.languageName')}</th>
                <th>{t('admin.languageCode')}</th>
                <th>{t('admin.enabled')}</th>
              </tr>
            </thead>
            <tbody>
              {ALL_LANGS.map((lang) => (
                <tr key={lang.code}>
                  <td>{lang.name}</td>
                  <td>{lang.code}</td>
                  <td>
                    <label className="adminLangToggle">
                      <input
                        type="checkbox"
                        checked={enabled[lang.code] !== false}
                        onChange={() => toggle(lang.code)}
                        disabled={lang.code === 'en'}
                      />
                      <span />
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button
            type="button"
            className="adminLangSaveBtn"
            onClick={save}
            disabled={saving}
          >
            {saving ? t('admin.loading') : t('common.save')}
          </button>
        </>
      )}
    </AdminLayout>
  );
}

export default AdminLanguages;
